export interface IMemberBasicInfoResponse {

    ID: number;
    Firstname: string;
    Lastname: string;
    Address1: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    Credit: number;

    AuthorizedContactFirstName : string;
    AuthorizedContactLastName : string;
    AuthorizedContactEmail : string;
    AuthorizedContactNote : string;

}

export class MemberBasicInfoResponse implements IMemberBasicInfoResponse {

    ID: number;
    Firstname: string;
    Lastname: string;
    Address1: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    Credit: number;

    AuthorizedContactFirstName : string;
    AuthorizedContactLastName : string;
    AuthorizedContactEmail : string;
    AuthorizedContactNote : string;

}